import { render, staticRenderFns } from "./ModalEditarItensPorVencedor.vue?vue&type=template&id=2b8e21f4&scoped=true"
import script from "./ModalEditarItensPorVencedor.vue?vue&type=script&lang=ts"
export * from "./ModalEditarItensPorVencedor.vue?vue&type=script&lang=ts"
import style0 from "./ModalEditarItensPorVencedor.vue?vue&type=style&index=0&id=2b8e21f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8e21f4",
  null
  
)

export default component.exports